export enum MasterDataEndpoint {
  Base = '/master-data',
  Find = '/find',
  Address = '/address',
  Carrier = '/carrier',
  User = '/user',
}
